module.exports = __webpack_public_path__ + "static/media/Hungry.8be9452c.png";